const prefixUrlWithProtocol = (url: string, protocol = 'https://') => {
  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.protocol === 'mailto:' || parsedUrl.protocol === 'tel:') {
      return url;
    }

    if (import.meta.env.PROD && parsedUrl.protocol === 'http:') {
      parsedUrl.protocol = 'https:';
      return parsedUrl.toString();
    }

    if (parsedUrl.protocol.startsWith('http')) {
      return url;
    }

    return `${protocol}${url}`;
  } catch {
    // If URL parsing fails, it means there's no protocol
    if (
      !url.startsWith('http://') &&
      !url.startsWith('https://') &&
      !url.startsWith('mailto:') &&
      !url.startsWith('tel:')
    ) {
      return `${protocol}${url}`;
    }
    return url;
  }
};

export { prefixUrlWithProtocol };
